import { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function PlanManagerPage() {
  const [pm, setPm] = useState({ business_name: "", manager_name: "", address: "", phone: "", email: "" });
  const upd = (k) => (e) => setPm((p) => ({ ...p, [k]: e.target.value }));

  useEffect(() => { (async () => { const { data } = await api.get("/plan-manager"); setPm(data); })(); }, []);

  const save = async () => {
    try { const { data } = await api.put("/plan-manager", pm); setPm(data); toast.success("Saved"); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  return (
    <div className="space-y-5 max-w-2xl" data-testid="plan-manager-page">
      <header>
        <h1 className="text-4xl font-display font-black tracking-tight">Plan Manager</h1>
        <p className="text-muted-foreground">Used for cover letters and invoice emailing.</p>
      </header>
      <Card className="rounded-3xl p-6 border-2 space-y-3">
        <F id="business_name" label="Business name" v={pm.business_name} oc={upd("business_name")} />
        <F id="manager_name" label="Manager's name" v={pm.manager_name} oc={upd("manager_name")} />
        <F id="address" label="Address" v={pm.address} oc={upd("address")} />
        <div className="grid sm:grid-cols-2 gap-3">
          <F id="phone" label="Phone" v={pm.phone} oc={upd("phone")} />
          <F id="email" label="Email" v={pm.email} oc={upd("email")} type="email" />
        </div>
        <Button onClick={save} className="rounded-full font-bold" style={{ background: "hsl(var(--client))" }} data-testid="save-pm-btn">Save</Button>
      </Card>
    </div>
  );
}

function F({ id, label, v, oc, type = "text" }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-xs uppercase font-bold tracking-wider">{label}</Label>
      <Input id={id} value={v || ""} onChange={oc} type={type} className="rounded-xl min-h-[48px]" data-testid={`pm-${id}`} />
    </div>
  );
}
